document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('.sticky-atc');

  if (!bar) {
    return;
  }

  var form = document.querySelector('.summary form.cart');
  var realButton = form && form.querySelector('.single_add_to_cart_button');

  if (!form || !realButton) {
    return;
  }

  bar.querySelector('.sticky-atc-button').addEventListener('click', function () {
    realButton.click();
  });

  if (!('IntersectionObserver' in window)) {
    return;
  }

  // Show the bar only after the in-summary cart form has scrolled up out of
  // view — not on load, and not when the user is above it.
  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;

      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    },
    { threshold: 0 }
  );

  observer.observe(form);
});
